const initialState= {
  popkey:null,
  info_user:false,
  isUserLogged:false,
  loading_user:true,
  error_log_type:false,
  error_signin:false,
  valid_signin:false,
  error_profile:false,
  valid_profile:false,
  loading_update:false,

}

export function userReducers(state=initialState,action){
	switch(action.type){
    case 'SET_POPKEY':
    return{
      ...state,
      popkey:action.payload
    }

    case 'GET_USER_INFO_LOADING':
    return{
      ...state,
      loading_user:true
    }

    case 'GET_USER_INFO':
    return{
      ...state,
      info_user:action.payload,
      isUserLogged:true,
      loading_user:false,
      popkey:action.payload.auth_token
    }

    case 'GET_USER_INFO_ERROR':
    return{
      ...state,
      loading_user:false,
      isUserLogged:false,
    }
    case 'NO_HAS_POPKEY':
    return{
      ...state,
      loading_user:false,
      isUserLogged:false,
    }
    case 'GO_CONNECT_USER_LOADING':
    return{
      ...state,
      loading_connect:true,
      error_log_type:false

    }

    case 'GO_CONNECT_USER_SUCCESS':
    return{
      ...state,
      loading_connect:false,
      isUserLogged:true,
      info_user:action.payload,
      popkey:action.payload.auth_token,
      error_log_type:false,
    }

    case 'GO_CONNECT_USER_ERROR':
    return{
      ...state,
      loading_connect:false,
      isUserLogged:false,
      error_log_type:action.payload
    }
    case 'REGISTER_USER_ERROR':

    return{
      ...state,
      error_signin:action.payload.error
    }

    case 'REGISTER_USER_SUCCESS':
    return{
      ...state,
      info_user:action.payload.info_user,
      popkey:action.payload.popkey,
      valid_signin:true
    }

    case 'CLEAR_VALID_SIGN_IN':
    return{
      ...state,
      valid_signin:false,
      isUserLogged:true,
    }
    case 'CLEAR_ERROR_SIGN_IN':
    return{
      ...state,
      error_signin:false
    }

    case 'CLEAR_VALID_PROFILE':
      return{
        ...state,
        valid_profile:false,
      }
    case 'DISCONNECT_USER':
    return{
      ...state,
      popkey:null,
      info_user:false,
      isUserLogged:false,
    }

    case 'UPDATE_PERSONNAL_DATA_LOADING':
    return{
      ...state,
      loading_update:true,

    }

    case 'UPDATE_PERSONNAL_DATA_SUCCESS':
    return{
      ...state,
      loading_update:false,
      valid_profile:true,
      info_user:{...state.info_user,firstname:action.payload.firstname,name:action.payload.name,pseudo:action.payload.pseudo}

    }

    case 'UPDATE_PERSONNAL_DATA_ERROR':
    return{
      ...state,
      loading_update:false,
      error_profile:action.payload.error
    }

    case 'CLEAR_ERROR_PROFILE':
    return{
      ...state,
      error_profile:false,
    }

    case 'UPDATE_AVATAR_LOADING':
    return{
      ...state,
      loading_update:true,

    }

    case 'UPDATE_AVATAR_SUCCESS':
    return{
      ...state,
      loading_update:false,
      valid_profile:true,
      info_user:{...state.info_user,avatar:action.payload}

    }

    case 'UPDATE_AVATAR_ERROR':
    return{
      ...state,
      loading_update:false,
      error_profile:action.payload.error
    }

    case 'UPDATE_BOAT_LOADING':
    return{
      ...state,
      loading_update:true,

    }
    case 'UPDATE_BOAT_SUCCESS':
    return{
      ...state,
      loading_update:false,
        valid_profile:true,
      info_user:{
        ...state.info_user,
        boat_immatriculation:action.payload.boat_immatriculation,
        boat_name:action.payload.boat_name,
        id_boat:action.payload.id_boat,
      }

    }
    case 'UPDATE_BOAT_ERROR':
    return{
      ...state,
      loading_update:false,
      error_profile:action.payload.error

    }

    case 'UPDATE_ADRESS_LOADING':
    return{
      ...state,
      loading_update:true,

    }

    case 'UPDATE_ADRESS_SUCCESS' :
      console.log(action.payload);
    return{
      ...state,
      loading_update:false,
      valid_profile:true,
      info_user:{
        ...state.info_user,
        adress_postal:action.payload.adress_postal
      }
    }

    case 'UPDATE_ADRESS_ERROR':
    return{
      ...state,
      loading_update:false,
      error_profile:action.payload.error

    }

    case 'UPDATE_PASSWORD_LOADING':
    return{
      ...state,
      loading_update:true,

    }

    case 'UPDATE_PASSWORD_SUCCESS':
    return{
      ...state,
      loading_update:false
    }

    case 'UPDATE_PASSWORD_ERROR':
    return{
      ...state,
      loading_update:false,
      error_profile:action.payload.error

    }
    case 'SET_INFO_BOAT_USER':
    return{
      ...state,
      info_user:{
        ...state.info_user,
        boat_immatriculation:action.payload.boat_immatriculation,
        boat_name:action.payload.boat_name,
        id_boat:action.payload.id_boat,
      }
    }

    case 'SET_INFO_ADRESS_USER':
    return{
      ...state,
      info_user:{
        ...state.info_user,
        adress_postal:action.payload.adress_postal
      }
    }

    default:
		  return state


    }

}
